import React from "react";
import { Calendar, ChevronRight } from "lucide-react";
import Button from "../Button";

const BookAppointment: React.FC = () => {
  return (
    <div className="mx-4 bg-white border border-gray-200 rounded-lg p-4">
      <div className="flex flex-row items-center justify-between">
        <div className="flex flex-row items-center gap-2">
          <Calendar className="w-4 h-4" />
          <span className="text-base font-medium">Book a Consultation</span>
        </div>

        <button className="text-gray-500 p-2 rounded-full hover:bg-gray-200">
          <ChevronRight className="w-4 h-4" />
        </button>
      </div>

      <div className="flex flex-row items-center gap-2 overflow-x-auto pt-4">
        <div className="flex flex-col items-center justify-center gap-2 bg-slate-100 rounded-lg p-4 min-w-44">
          <div className="w-20 h-20 bg-slate-600 text-white rounded-full flex items-center justify-center text-2xl font-bold">
            S
          </div>
          <div className="text-md font-thin">Care Specialist</div>
          <div className="text-md text-green-600 font-semibold -mt-2">
            ₹ 100
          </div>
          <Button size="sm" variant="contained" rounded="full" fullWidth>
            Book
          </Button>
        </div>

        <div className="flex flex-col items-center justify-center gap-2 bg-slate-100 rounded-lg p-4 min-w-44">
          <div className="w-20 h-20 bg-slate-600 text-white rounded-full flex items-center justify-center text-2xl font-bold">
            S
          </div>
          <div className="text-md font-thin">Care Specialist</div>
          <div className="text-md text-green-600 font-semibold -mt-2">
            ₹ 100
          </div>
          <Button size="sm" variant="contained" rounded="full" fullWidth>
            Book
          </Button>
        </div>

        <div className="flex flex-col items-center justify-center gap-2 bg-slate-100 rounded-lg p-4 min-w-44">
          <div className="w-20 h-20 bg-slate-600 text-white rounded-full flex items-center justify-center text-2xl font-bold">
            S
          </div>
          <div className="text-md font-thin">Care Specialist</div>
          <div className="text-md text-green-600 font-semibold -mt-2">
            ₹ 100
          </div>
          <Button size="sm" variant="contained" rounded="full" fullWidth>
            Book
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BookAppointment;
